import React, { useEffect, useState } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import MyDocument from "./MyDocument";
import { useParams } from "react-router-dom";
import useAxios from "../../../../Utils/useAxios";

const PDFViewerComponentUMK = () => {
  const { formId } = useParams();
  const axiosInstance = useAxios();
  const [formUMK, setFormUMK] = useState({});
  const [anggaranUMK, setAnggaranUMK] = useState([]);
  const [anggaranDipakaiUMK, setAnggaranDipakaiUMK] = useState([]);
  const [unitKerjaList, setUnitKerjaList] = useState([]);
  useEffect(() => {
    getUMK();
    getUnitKerja();
  }, []);

  const getUMK = async () => {
    try {
      const response = await axiosInstance.get(`umk/${formId}`);
      if (response.status === 200) {
        setFormUMK(response.data);
        let umkData = response.data;
        try {
          const response = await axiosInstance.get(
            `anggaran-dipakai-umk/dokumen/${umkData.id_umk}`
          );
          if (response.status === 200) {
            setAnggaranUMK(response.data);
          }
        } catch (e) {
          console.error(e);
        }
        try {
          const response = await axiosInstance.get(
            `anggaran-dipakai-umk/anggaran-dipakai/${umkData.id_umk}`
          );
          if (response.status === 200) {
            setAnggaranDipakaiUMK(response.data);
          }
        } catch (e) {
          console.error(e);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getUnitKerja = async () => {
    try {
      const response = await axiosInstance.get("unitkerja/");
      if (response.status === 200) {
        setUnitKerjaList(response.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <PDFViewer width="1444" height="1444">
      <MyDocument
        formUMK={formUMK}
        anggaranUMK={anggaranUMK}
        unitKerjaList={unitKerjaList}
        anggaranDipakaiUMK={anggaranDipakaiUMK}
      />
    </PDFViewer>
  );
};

export default PDFViewerComponentUMK;
